import { getOptions } from '@ourbranch/lookups';

export const getHighestEducationAppCoApp = (peopleIn) => {
  const options = getOptions('highestEducation');
  const appAndCoApp = peopleIn.filter((p) => p.isPrimary || p.isCoApplicant);
  const educationKeys = options.map((option) => option.id).reverse(); // reverse so that highest education is first
  let highestEducation;
  for (const educationKey of educationKeys) {
    const hasEducationlevel = appAndCoApp.some((p) => p.highestEducation === educationKey);
    if (hasEducationlevel) {
      highestEducation = educationKey;
      break; // breaking out of loop because we found the highest education due to the reversed order of educationKeys
    }
  }
  return highestEducation;
};

export const getOldestAppCoApp = (people) => {
  return people
    .filter((p) => p.isPrimary || p.isCoApplicant)
    .reduce((currentOldestAge, person) => Math.max(currentOldestAge, person.age), 0);
};

export const formatValues = (values) => {
  if (!values) {
    return null;
  }
  return {
    ...values,
    oldestResident: undefined,
    highestEducation: undefined
  };
};
